import React from 'react';
import PropType from 'prop-types';
import Icon from '../../../00_atoms/icon/Icon';

/*
 * Control Module
 * ---------------------
 * This small module provides the controls necessary to interact with the BC player
 */

class AudioPlayerComponentActiveMediaControl extends React.Component {
  constructor(props) {
    super(props);
    window.audioPlayerTickTimeUpdate = this.tickTimeUpdate;

    this.state = {
      progressBar: 0,
    };
  }

  tickTimeUpdate = (percentage = null) => {
    let newPercentage;

    if(!percentage) {
      const currentTime = jwplayer('audio').getPosition();
      const maxDuration = jwplayer('audio').getDuration();

      if (maxDuration <= 0) return;
      if (currentTime > maxDuration) return;
      if (currentTime < 0) return;

      newPercentage = (currentTime / maxDuration) * 100;
    } else {
      newPercentage = percentage;
    }


    const progressEl = document.querySelector(
      '#po-audio-player__component-active-media__control__progress-bar__total-progress'
    );
    if (progressEl) {
      progressEl.style.width = `${newPercentage}%`;
    }
  };

  handleProgressBarInputChange = event => {
    console.log(event);
    if (event.target.value < 0) return;
    if (event.target.value > 100) return;
    this.setState({
      progressBar: event.target.value,
    });
    console.log(event.target.value);
    this.props.handleProgressBarInput(event.target.value);
  };

  render() {
    // const dataActiveShow = this.props.dataActiveShow;
    // const dataPodcast = this.props.dataPodcast;
    const audioState = this.props.audioState;
    const isExpanded = this.props.isExpanded;

    const isExpandedClass = isExpanded
      ? `po-audio-player__component-active-media__control--is-expanded`
      : `po-audio-player__component-active-media__control--is-minified`;

    return (
      <div
        className={`po-audio-player__component-active-media__control ${isExpandedClass}`}
      >
        <div
          className={`po-audio-player__component-active-media__control__buttons ${
            isExpanded
              ? `po-audio-player__component-active-media__control__buttons--is-expanded`
              : `po-audio-player__component-active-media__control__buttons--is-minified`
          }`}
        >
          <div
            className={`po-audio-player__component-active-media__control__button__container`}
          >
            {audioState === 'podcast on' && !isExpanded ? (
              <div>
                <div
                  onClick={this.props.handlePlayPause}
                  className={`po-audio-player__component-active-media__control__button`}
                >
                  <Icon
                    iconName={`Pause`}
                    iconTitle={`Pause`}
                    xLink={`/wp-content/themes/arn/assets/icons/sprite.svg`}
                  />
                </div>
              </div>
            ) : null}
            {audioState === 'podcast on' && isExpanded ? (
              <div>
                <div
                  onClick={this.props.handleSkipBackward}
                  className={`po-audio-player__component-active-media__control__button`}
                >
                  <Icon
                    iconTitle={`Rewind`}
                    iconName={`ArrowBack`}
                    xLink={`/wp-content/themes/arn/assets/icons/arrow_loop_back.svg`}
                  />
                </div>
                <div
                  onClick={this.props.handlePlayPause}
                  className={`po-audio-player__component-active-media__control__button`}
                >
                  <Icon
                    iconName={`Pause`}
                    iconTitle={`Pause`}
                    xLink={`/wp-content/themes/arn/assets/icons/sprite.svg`}
                  />
                </div>
                <div
                  onClick={this.props.handleSkipForward}
                  className={`po-audio-player__component-active-media__control__button`}
                >
                  <Icon
                    iconTitle={`Fast Forward`}
                    iconName={`ArrowForward`}
                    xLink={`/wp-content/themes/arn/assets/icons/arrow_loop_forward.svg`}
                  />
                </div>
              </div>
            ) : null}
            {audioState === 'stream on' ? (
              <div
                onClick={this.props.handlePlayPause}
                className={`po-audio-player__component-active-media__control__button`}
              >
                <Icon
                  iconName={`Pause`}
                  iconTitle={`Pause`}
                  xLink={`/wp-content/themes/arn/assets/icons/sprite.svg`}
                />
              </div>
            ) : null}
            {(audioState === 'podcast off' || audioState === 'stream off') &&
            !isExpanded ? (
              <div
                onClick={this.props.handlePlayPause}
                className={`po-audio-player__component-active-media__control__button`}
              >
                <Icon
                  iconName={`Play`}
                  iconTitle={`Play`}
                  xLink={`/wp-content/themes/arn/assets/icons/sprite.svg`}
                />
              </div>
            ) : null}
          </div>
        </div>
        {isExpanded && audioState === 'podcast on' ? (
          <div>
            <div
              className={`po-audio-player__component-active-media__control__progress-bar`}
            >
              <div
                className={`po-audio-player__component-active-media__control__progress-bar-inner`}
              >
                <input
                  type="range"
                  min="0"
                  max="100"
                  value={this.state.progressBar}
                  onChange={this.handleProgressBarInputChange}
                  className="po-audio-player__component-active-media__control__progress-bar__slider"
                  id="po-audio-player__component-active-media__control__progress-bar__slider"
                />
                <div
                  id={`po-audio-player__component-active-media__control__progress-bar__total-progress`}
                  className={`po-audio-player__component-active-media__control__progress-bar__total-progress`}
                />
                <div
                  className={`po-audio-player__component-active-media__control__progress-bar__total-buffer`}
                />
              </div>
            </div>
          </div>
        ) : null}
      </div>
    );
  }
}

AudioPlayerComponentActiveMediaControl.propTypes = {
  // dataActiveShow: PropType.object.isRequired,
  audioState: PropType.string.isRequired,
  // dataPodcast: PropType.object.isRequired,
  isExpanded: PropType.bool.isRequired,
  handlePlayPause: PropType.func.isRequired,
  handleSkipForward: PropType.func.isRequired,
  handleSkipBackward: PropType.func.isRequired,
  handleProgressBarInput: PropType.func.isRequired,
};

export default AudioPlayerComponentActiveMediaControl;
